import React from "react";
import { Box, Button, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
      }}
    >
      {/* Success Icon */}
      <CheckCircleIcon sx={{ fontSize: 80, color: "green", marginBottom: 2 }} />

      {/* Success Message */}
      <Typography variant="h5" sx={{ color: "green", fontWeight: "bold" }}>
        {t("PaymentSuccess")}
      </Typography>

      {/* Home Button */}
      <Button
        variant="contained"
        sx={{
          marginTop: 3,
          backgroundColor: "#f26456",
          color: "white",
          padding: "10px 30px",
          fontSize: "16px",
          borderRadius: "8px",
        }}
        onClick={() => navigate("/orders")}
      >
        {t("Home")}
      </Button>
    </Box>
  );
};

export default PaymentSuccess;
